module.exports = __webpack_public_path__ + "static/media/system_flow_credit_schedule.fae6ce3c.svg";